import { features } from "@/mocks/guage";

const toneMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: "bg-primary-100", text: "text-primary-700", border: "border-primary-200" },
  accent: { bg: "bg-accent-100", text: "text-accent-800", border: "border-accent-200" },
  secondary: { bg: "bg-secondary-100", text: "text-secondary-800", border: "border-secondary-200" },
};

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-2 text-secondary-700 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-secondary-500"></span>
              瓜哥宗旨
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
              不跟风，
              <br />
              不站队，
              <br />
              只讲门道
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              热点每天都在换，判断的方法却不会过期。瓜哥吃瓜把每一场热闹拆成时间线、细节和观点三部分，
              先让你看懂，再让你笑出声。
            </p>
            <a
              href="#feature"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              读一篇精选长评
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {features.map((feature) => {
              const tone = toneMap[feature.tone] ?? toneMap.primary;
              return (
                <article
                  key={feature.title}
                  className="group p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
                >
                  <span
                    className={`w-12 h-12 flex items-center justify-center rounded-lg border ${tone.bg} ${tone.text} ${tone.border}`}
                  >
                    <i className={`${feature.icon} text-2xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-xl md:text-2xl text-foreground-950">
                    {feature.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}